import * as path from "node:path";
import { checkHasProjectFile } from "@prismicio/plugin-kit/fs";
async function buildSrcPath(args) {
  const hasSrcDirectory = await checkHasProjectFile({
    filename: "src",
    helpers: args.helpers
  });
  return hasSrcDirectory ? path.join("src", args.filename) : args.filename;
}
export {
  buildSrcPath
};
//# sourceMappingURL=buildSrcPath.js.map
